import { PERMISSIONS } from '@/types/access';

type HasPermission = (permission: string) => boolean;

export interface NavLink {
  to: string;
  icon: string;
  label: string;
  visible: (hasPermission: HasPermission) => boolean;
}

export interface NavGroup {
  label: string;
  items: NavLink[];
}

const needs =
  (...permissions: string[]) =>
  (hasPermission: HasPermission): boolean =>
    permissions.every((permission) => hasPermission(permission));

const NAV_GROUPS: readonly NavGroup[] = [
  {
    label: 'Operations',
    items: [
      { to: '/scheduling', icon: 'clipboard-list', label: 'Scheduling', visible: needs(PERMISSIONS.READ_PO, PERMISSIONS.READ_CAPACITY) },
      { to: '/po-tracker', icon: 'truck', label: 'PO Tracker', visible: needs(PERMISSIONS.READ_PO_TRACKER) },
      { to: '/po-activity', icon: 'clock', label: 'PO Activity', visible: needs(PERMISSIONS.READ_PO_ACTIVITY) },
    ],
  },
  {
    label: 'Capacity',
    items: [
      { to: '/capacity-calendar', icon: 'calendar', label: 'Capacity Calendar', visible: needs(PERMISSIONS.READ_CAPACITY) },
      { to: '/capacity-import', icon: 'upload', label: 'Capacity Import', visible: needs(PERMISSIONS.IMPORT_CAPACITY) },
    ],
  },
  {
    label: 'Admin',
    items: [
      { to: '/vendors', icon: 'office-building', label: 'Vendors', visible: needs(PERMISSIONS.READ_VENDORS) },
      { to: '/customer-mappings', icon: 'tag', label: 'Customer Mappings', visible: needs(PERMISSIONS.READ_CUSTOMER_MAPPINGS) },
      { to: '/manage-access', icon: 'key', label: 'Manage Access', visible: needs(PERMISSIONS.MANAGE_ACCESS, PERMISSIONS.READ_VENDORS) },
    ],
  },
];

export function visibleNavGroups(hasPermission: HasPermission): NavGroup[] {
  return NAV_GROUPS.map((group) => ({ ...group, items: group.items.filter((item) => item.visible(hasPermission)) })).filter((group) => group.items.length > 0);
}
